import React from 'react'
import styled from 'styled-components'
import MainVideo from '../assets/Walking Girl.mp4';
import {motion} from 'framer-motion';


const VideoContainer = styled.section`
    width: 100%;
    height: 100vh;
    position: relative;

    video{
        height: 100%;
        width: 100%;
        object-fit: cover;

        @media (max-width:48em){
            object-position: center 50%;
        }
    }
    @media (max-width:30em){
        object-position: center 50%;
    }
`
const DarkOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: ${props=>`rgba(${props.theme.bodyRgba},0.6)`};
`
const Title = styled(motion.div)`
    position: absolute;
    top: 0;
    bottom: 0;
    left:0;
    right: 0;
    z-index: 1;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${props=>props.theme.text};



    div{
        display: flex;
        flex-direction: row;
    }
    h1{
        font-family: "Kaushan script";
        font-size: ${props=>props.theme.fontBig};
        text-shadow: 1px 1px 1px ${props=>props.theme.body};

        @media (max-width:30em){
            font-size: calc(5rem + 7vw);
        }
    }
    h2{
        font-family: 'sirin stencil';
        font-weight: 300;
        text-transform: capitalize;
        font-size: ${props=>props.theme.fontlg};
        text-shadow: 1px 1px 1px ${props=>props.theme.body};

        @media (max-width:30em){
            font-size: ${props=>props.theme.fontmd};
            margin-top: -1rem;
        }
    }
`
const container = {
    hidden : {
        opacity : 0,
    },
    show : {
        opacity : 1,

        transition : {
            delayChildren : 3,
            staggerChildren : 0.3,

        }
    },
}
const item = {
    hidden : {
        opacity : 0
    },
    show : {
        opacity : 1
    }
}


const VideoCover = () => {
  return (
    <VideoContainer>
        <DarkOverlay/>
        <Title variants = {container} initial = "hidden" animate = "show">
            <div>
                <motion.h1 variants = {item}  data-scroll data-scroll-delay="0.13" data-scroll-speed="4">X</motion.h1>
                <motion.h1 variants = {item} data-scroll data-scroll-delay="0.09" data-scroll-speed="4">O</motion.h1>
                <motion.h1 variants = {item} data-scroll data-scroll-delay="0.06" data-scroll-speed="4">L</motion.h1>
                <motion.h1 variants = {item} data-scroll data-scroll-delay="0.04" data-scroll-speed="4">O</motion.h1>

            </div>
            <motion.h2 variants={item} data-scroll data-scroll-speed="0.14">Inspire. Create. Belive</motion.h2>
        </Title>
        <video src={MainVideo} type="video/mp4" autoPlay muted loop></video>
    </VideoContainer>
  )
}

export default VideoCover